import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames';
// import { Link } from 'react-router-dom';
import ShowPropertiesByClient from './../properties/ShowPropertiesByClient';
import ShowPropertiesByUser from './../properties/ShowPropertiesByUser';
import AddProperty from './../properties/AddProperty';
import EditProperty from './../properties/EditProperty';
import EditUser from './../users/EditUser';
import EditClient from './../clients/EditClient';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Growl } from 'primereact/growl';
import ShowPropertiesWithContactsByClient from './../properties/ShowPropertiesWithContactsByClient';
import { Helmet } from 'react-helmet';
import About from './../../pages/About';
import Privacy from './../../pages/Privacy';
class ClientDashBoard extends Component {
  constructor() {
    super();
    document.title = 'Ikar.sy';
  }
  state = {
    pageTitle: 'صفحة العميل| Ikar.sy',
    pageDescription: '',
    linkTo: 'default',
    locationSearch: '',
  };
  activateSideBarItems = () => {
    let sidebarLinks = document.querySelectorAll('.dashboard-sidebar-link');
    sidebarLinks.forEach(function (link) {
      link.addEventListener('click', function () {
        // Set clicked image as display image.
        // let newImageSrc = link.dataset.largeVersion;
        //mainImage.setAttribute('src', newImageSrc);
        // Change which image is current.
        document
          .querySelector('.dashboard-active')
          .classList.remove('dashboard-active');
        link.parentNode.classList.add('dashboard-active');
      });
    });
  };
  async componentWillReceiveProps(nextProps, nextState) {
    if (nextProps.location.search !== this.state.locationSearch) {
      await this.setState({ locationSearch: nextProps.location.search });
    }
    // if (nextProps.match.params.to !== this.state.LinkTo) {
    //   this.setState({ linkTo: nextProps.match.params.to });
    // }
  }
  componentDidMount() {
    if (this.props.location.search !== this.state.locationSearch) {
      this.setState({ locationSearch: this.props.location.search });
    }
    const { to } = this.props.match.params;
    
    if (this.props.isBlocked) {
      this.growl.show({life:5000,
        severity: 'warn',
        summary: 'لا تمتلك صلاحية تنفيذ الاجراء المطلوب',
        detail: <span> الرجاء التواصل مع   <a
                href="tel:00963981785225"
                // onClick="ga('send', 'event', { eventCategory: 'Contact', eventAction: 'Call', eventLabel: 'Mobile Button'});"
                style={{ color: '#f18805' }}
              >      { ' إدارة الموقع '}
              </a>
                 لتفعيل الحساب عبر  
        <a
                href="tel:00963981785225"
                // onClick="ga('send', 'event', { eventCategory: 'Contact', eventAction: 'Call', eventLabel: 'Mobile Button'});"
                style={{ color: '#f18805' }}
              >{' الاتصال ' }
              </a>
              أو عبر 
              <a
              href={`https://wa.me/+963981785225?text=${encodeURI(
                                                  `مرحباً, الرجاء تفعيل حسابي، : الاسم: ${localStorage.getItem('ikar_name')} - المعرف: ${localStorage.getItem('ikar_agency_ref_id')}    `
                                                )}`}
                // onClick="ga('send', 'event', { eventCategory: 'Contact', eventAction: 'Call', eventLabel: 'Mobile Button'});"
                style={{ color: '#f18805' }}
              > الواتساب
              </a>
              </span>
        // 'الرجاء التواصل مع ادارة الموقع لتفعيل الحساب',
      });
    } else {
      this.setState({ linkTo: to });
      this.activateSideBarItems();
    }
  }
  handleLinkTo = (linkTo, e) => {
    if (this.props.isBlocked) {
     this.growl.show({life:5000,
        severity: 'warn',
        summary: 'لا تمتلك صلاحية تنفيذ الاجراء المطلوب',
        detail: <span> الرجاء التواصل مع   <a
                href="tel:00963981785225"
                // onClick="ga('send', 'event', { eventCategory: 'Contact', eventAction: 'Call', eventLabel: 'Mobile Button'});"
                style={{ color: '#f18805' }}
              >      { ' إدارة الموقع '}
              </a>
                 لتفعيل الحساب عبر  
        <a
                href="tel:00963981785225"
                // onClick="ga('send', 'event', { eventCategory: 'Contact', eventAction: 'Call', eventLabel: 'Mobile Button'});"
                style={{ color: '#f18805' }}
              >{' الاتصال ' }
              </a>
              أو عبر 
              <a
                 href={`https://wa.me/+963981785225?text=${encodeURI(
                                                  `مرحباً, الرجاء تفعيل حسابي، : الاسم: ${localStorage.getItem('ikar_name')} - المعرف: ${localStorage.getItem('ikar_agency_ref_id')}`
                                                )}`}
                                                        style={{ color: '#f18805' }}
              > الواتساب
              </a>
              </span>
        // 'الرجاء التواصل مع ادارة الموقع لتفعيل الحساب',
      });
    }
     else {
      this.setState({ linkTo });
    }
  };
  render() {
    const { linkTo } = this.state;
    const {
      // isTakingClientRole, takenClientRoleEmail,
      isBlocked,
    } = this.props;
    return (
      <div>
        <Helmet>
          <title>{this.state.pageTitle}</title>
          <meta name="description" content={this.state.pageDescription} />
          <meta name="robots" content="noindex" />
        </Helmet>
        <div className="container-fluid">
          <Growl ref={(el) => (this.growl = el)} />
          <div className="row">
            <div className="col-12 dashboard-sidebar">
              <nav className="navbar navbar-expand-lg navbar-light ">
                <div className="bottom-border text-center text-warning ">
                  <FontAwesomeIcon
                    icon={['fas', 'user-cog']}
                    size="2x"
                    color="#F8C012"
                  />
                  <br />
                  عميل عقاري
                </div>
                <ul className="navbar-nav ml-auto my-auto">
                <li className="nav-item mx-1">
                    <a
                      href="/clientDashBoard/show_about_by_client"
                      //className="nav-link text-white p-1 mx-1 dashboard-sidebar-link"
                      className={classnames(
                        'nav-link',
                        'text-white',
                        'p-1',
                        'mx-1',
                        'dashboard-sidebar-link',
                        { 'dashboard-active': linkTo === 'show_about_by_client' }
                      )}
                    
                    >
                      <FontAwesomeIcon
                        icon={['fas', 'search']}
                        className="text-light mr-2"
                      />
                       {' '}
                  IKAR حول 
                    {' '}
                    </a>
                  </li>
           
                  <li className="nav-item mx-1" style={{ display: 'none' }}>
                    <a
                      href="#!"
                      className="nav-link text-white p-1 mx-1 dashboard-sidebar-link dashboard-active"
                      // onClick={this.handleLinkTo.bind(this, 'edit_user')}
                    >
                      <FontAwesomeIcon
                        icon={['fas', 'plus']}
                        className="text-light mr-2"
                      />
                      لوحة التحكم
                    </a>
                  </li>
                  <li className="nav-item mx-1">
                    {/* <Link
                      to="/dashBoard/properties_contacts" */}
                    <a
                      href="/clientDashBoard/properties_contacts"
                      //className="nav-link text-white p-1 mx-1 dashboard-sidebar-link"
                      className={classnames(
                        'nav-link',
                        'text-white',
                        'p-1',
                        'mx-1',
                        'dashboard-sidebar-link',
                        { 'dashboard-active': linkTo === 'properties_contacts' }
                      )}
                      // onClick={this.handleLinkTo.bind(
                      //   this,
                      //   'properties_contacts'
                      // )}
                    >
                      <FontAwesomeIcon
                        icon={['fas', 'search']}
                        className="text-light mr-2"
                      />
                      رسائل العميل
                    </a>
                  </li>
                
                  {/* <li className="nav-item mx-1">
                    <Link
                      to="/dashBoard/edit_user"
                      //className="nav-link text-white p-1 mx-1 dashboard-sidebar-link"
                      className={classnames(
                        'nav-link',
                        'text-white',
                        'p-1',
                        'mx-1',
                        'dashboard-sidebar-link',
                        { 'dashboard-active': linkTo === 'edit_user' }
                      )}
                      //onClick={this.handleLinkTo.bind(this, 'edit_user')}
                    >
                      <FontAwesomeIcon
                        icon={['fas', 'edit']}
                        className="text-light mr-2"
                      />
                      تعديل المستخدم
                    </Link>
                  </li> */}
                  <li className="nav-item mx-1">
                    <a
                      href="/clientDashBoard/edit_client"
                      //className="nav-link text-white p-1 mx-1 dashboard-sidebar-link"
                      className={classnames(
                        'nav-link',
                        'text-white',
                        'p-1',
                        'mx-1',
                        'dashboard-sidebar-link',
                        { 'dashboard-active': linkTo === 'edit_client' }
                      )}
                      // onClick={this.handleLinkTo.bind(this, 'edit_client')}
                    >
                      <FontAwesomeIcon
                        icon={['fas', 'edit']}
                        className="text-light mr-2"
                      />
                      تعديل العميل
                    </a>
                  </li>
                  <li className="nav-item mx-1">
                    <a
                      href="/clientDashBoard/add_property"
                      //className="nav-link text-white p-1 mx-1 dashboard-sidebar-link"
                      className={classnames(
                        'nav-link',
                        'text-white',
                        'p-1',
                        'mx-1',
                        'dashboard-sidebar-link',
                        { 'dashboard-active': linkTo === 'add_property' }
                      )}
                      // onClick={this.handleLinkTo.bind(this, 'add_property')}
                    >
                      <FontAwesomeIcon
                        icon={['fas', 'plus-square']}
                        className="text-light mr-2"
                      />
                      اضافة عقار
                    </a>
                  </li>
                  <li className="nav-item mx-1">
                    <a
                      href="/clientDashBoard/properties_by_client"
                      //className="nav-link text-white p-1 mx-1 dashboard-sidebar-link"
                      className={classnames(
                        'nav-link',
                        'text-white',
                        'p-1',
                        'mx-1',
                        'dashboard-sidebar-link',
                        {
                          'dashboard-active': linkTo === 'properties_by_client',
                        }
                      )}
                      // onClick={this.handleLinkTo.bind(
                      //   this,
                      //   'properties_by_client'
                      // )}
                    >
                      <FontAwesomeIcon
                        icon={['fas', 'city']}
                        className="text-light mr-2"
                      />
                      عقارات العميل
                    </a>
                  </li>
                  {/* <li className="nav-item mx-1">
                    <Link
                      to="/properties_by_user"
                      className="nav-link text-white p-1 mx-1 dashboard-sidebar-link"
                      onClick={this.handleLinkTo.bind(
                        this,
                        'properties_review_by_user'
                      )}
                    >
                      <FontAwesomeIcon
                        icon={['fas', 'city']}
                        className="text-light mr-2"
                      />
                      عقارات المستخدم
                    </Link>
                  </li> */}  
                </ul>
              </nav>
            </div>
            <div className="col-12">
              {isBlocked !== true ? (
                <React.Fragment>
                  {/* {linkTo === undefined ? <AddProperty /> : null} */}
                  {linkTo === 'edit_property' ? (
                    <EditProperty
                      // property_id={this.props.dashboardPath.id}
                      locationSearch={this.state.locationSearch}
                      aIkar={true}
                      destination="clientDashBoard"
                    />
                  ) : null}
                  {linkTo === 'edit_user' ? <EditUser /> : null}
                  {linkTo === 'show_about_by_client' ? <About /> : null}
                  {linkTo === 'show_privacy_by_client' ? <Privacy /> : null}
                  {linkTo === 'edit_client' ? <EditClient /> : null}
                  {linkTo === 'add_property' ? <AddProperty /> : null}
                  {linkTo === 'properties_by_client' ? (
                    <ShowPropertiesByClient
                      locationSearch={this.state.locationSearch}
                      destination="clientDashBoard"
                      aIkar={false}
                      // isAdminTakingClientRole={isTakingClientRole}
                      // takenClientRoleEmail={takenClientRoleEmail}
                    />
                  ) : null}
                  {linkTo === 'properties_contacts' ? (
                    <ShowPropertiesWithContactsByClient
                      locationSearch={this.state.locationSearch}
                    />
                  ) : null}
                  {linkTo === 'properties_by_user' ? (
                    <ShowPropertiesByUser
                    // isAdminTakingClientRole={isTakingClientRole}
                    // takenClientRoleEmail={takenClientRoleEmail}
                    />
                  ) : null}
                </React.Fragment>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
ClientDashBoard.propTypes = {
  isTakingAgencyRole: PropTypes.bool.isRequired,
  // takenAgencyRoleEmail: PropTypes.string.isRequired,
  isBlocked: PropTypes.bool.isRequired,
};
const mapStateToProps = (state) => ({
  dashboardPath: state.setting.dashboardPath,
  isTakingAgencyRole: state.auth.isTakingAgencyRole,
  isBlocked: state.auth.isBlocked,
  takenAgencyRoleEmail: state.auth.takenAgencyRoleEmail,
});

export default connect(mapStateToProps)(ClientDashBoard);
